module.exports = __webpack_public_path__ + "assets/img/planning-item-1.ba6085bd.svg";